import React, { useEffect, useRef } from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { pillars } from '../mock';

const Hero = ({ onOpenPortal }) => {
  const navigate = useNavigate();

  return (
    <section className="px-4 md:px-10 pt-6 pb-4 relative">
      {/* HERO — transparent so global RSW background video shines through */}
      <div className="relative mx-auto max-w-[1240px] overflow-hidden rounded-3xl border border-white/20 bg-transparent">
        <div className="absolute inset-0 bg-gradient-to-br from-[#040d08]/50 via-[#040d08]/20 to-[#040d08]/60 pointer-events-none" />
        <div className="absolute inset-0 radial-fade pointer-events-none opacity-40" />

        <div className="relative p-6 md:p-10 lg:p-14 min-h-[560px] flex flex-col justify-end">
          <div className="animate-fade-up max-w-4xl">
            <h1 className="font-serif text-white text-[46px] sm:text-[64px] lg:text-[86px] leading-[1.02] tracking-[-0.02em] text-balance drop-shadow-[0_2px_20px_rgba(0,0,0,0.7)]">
              Become a co-owner of <span className="italic text-emerald-300">green</span> transport innovation.
            </h1>
            <p className="mt-6 max-w-2xl text-emerald-50/90 text-[15px] md:text-[16px] leading-relaxed drop-shadow-[0_2px_10px_rgba(0,0,0,0.6)]">
              Join a global ecosystem building elevated string transport, structural bridges and autonomous AI robotics — built to move cities without moving the climate.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <button
              onClick={onOpenPortal}
              className="group inline-flex items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-medium px-6 py-3 shadow-[0_0_30px_rgba(34,197,94,0.45)] transition"
            >
              Explore Packages
              <ChevronRight size={16} className="group-hover:translate-x-1 transition" />
            </button>
            <button className="inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/10 hover:bg-white/20 text-white px-6 py-3 backdrop-blur transition">
              Watch Cinematic
            </button>
          </div>
        </div>
      </div>

      {/* PILLARS — solid white card that hides the video from here downwards */}
      <div id="pillars" className="mx-auto max-w-[1240px] mt-6 relative scroll-mt-24">
        <div className="rounded-3xl border border-emerald-900/15 bg-white shadow-[0_2px_30px_rgba(4,45,25,0.08)] p-6 md:p-8">
          <div className="flex items-end justify-between flex-wrap gap-3 mb-5">
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700">Integrated Frameworks</div>
              <h3 className="mt-1 font-serif text-emerald-950 text-[24px] md:text-[28px] leading-tight">
                An ecosystem built on three major pillars
              </h3>
            </div>
            <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700/70 hidden md:inline">
              Click a pillar to view full technical documentation
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {pillars.map((p) => (
              <button
                key={p.id}
                onClick={() => navigate(`/pillar/${p.slug}`)}
                className="group text-left flex flex-col justify-between gap-4 rounded-2xl border border-emerald-900/15 bg-[#f7f3df] hover:bg-[#fbf4dc] hover:border-emerald-700/40 p-5 min-h-[160px] transition"
              >
                <div>
                  <div className="inline-flex items-center gap-2 rounded-full bg-emerald-100 border border-emerald-700/40 text-emerald-800 text-[10px] font-semibold uppercase tracking-[0.16em] px-2.5 py-1">
                    Pillar 0{p.id}
                  </div>
                  <div className="mt-3 text-[17px] font-medium text-emerald-950 leading-snug">{p.title}</div>
                  <div className="mt-2 text-[13.5px] text-emerald-900/70 leading-relaxed">{p.description}</div>
                </div>
                <div className="inline-flex items-center gap-1.5 text-emerald-700 text-sm font-medium">
                  Read documentation <ChevronRight size={14} className="group-hover:translate-x-1 transition" />
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
